import { defineStore } from 'pinia'
import { percent } from './config'

export enum CautionLevel {
  healthy,
  normal,
  caution,
  serious,
}
export const getLevel = (n: number): CautionLevel => {
  return n < 4.4
    ? CautionLevel.healthy
    : n < 6.8
      ? CautionLevel.normal
      : n < 8.5
        ? CautionLevel.caution
        : CautionLevel.serious
}

export enum AggKey {
  mulung = 'mulung',
  umgyuk = 'umgyuk',
  kongkong = 'kongkong',
  godok = 'godok',
  buruk = 'buruk',
}

export const cautionLevelToKorName = (level: CautionLevel) => {
  switch (level) {
    case CautionLevel.healthy:
      return '건강'
    case CautionLevel.normal:
      return '보통'
    case CautionLevel.caution:
      return '주의'
    case CautionLevel.serious:
      return '심각'
  }
}

export const villainName = (aggKey: string) => {
  switch (aggKey) {
    case AggKey.buruk:
      return '버럭이'
    case AggKey.kongkong:
      return '콩콩이'
    case AggKey.godok:
      return '고독이'
    case AggKey.mulung:
      return '물렁이'
    case AggKey.umgyuk:
      return '엄격이'
    default:
      return ''
  }
}

type Result = {
  character: string
  characterKor: string
  score: number
  level: number
  percent: number
  levelKor: string
}
type State = {
  result: Result[]
  showOtherCharacter: boolean
  showTwoMore: boolean
}

export const useStore = defineStore('ExamResult', {
  state: (): State => {
    return {
      result: [],
      showOtherCharacter: false,
      showTwoMore: false,
    }
  },
  actions: {
    setScores (this: State, results: Pick<Result, 'character' | 'score'>[]) {
      this.result = results.map(el => ({
        character: el.character,
        characterKor: villainName(el.character),
        score: el.score,
        level: getLevel(el.score),
        levelKor: cautionLevelToKorName(getLevel(el.score)),
        percent:
          (percent.byVillain[el.character].byCl[getLevel(el.score)] /
            percent.byVillain[el.character].numTests) *
          100,
      }))
    },
  },
})
